// extracted by mini-css-extract-plugin
export var animation = "DescriptionWithAnimation-module--animation--e53bb";
export var animationOnRight = "DescriptionWithAnimation-module--animation-on-right--3190f";
export var container = "DescriptionWithAnimation-module--container--9ca53";
export var content = "DescriptionWithAnimation-module--content--71ee2";